module.exports = __webpack_public_path__ + "static/media/BiometricVerification.77a7ced1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/BiometricVerification.svg
// module id = 1371
// module chunks = 0